'use strict';
require('../components/spinner');
const MicroModal = require('micromodal');

const getElements = function () {
    return {
        brand_button: $('.listing-brand-button .brand-detail-a'),
        modal_close_button: $('#listing-brand-modal').find('.modal-close'),
        modal_container: $('#listing-brand-modal').find('.brand-container-detail'),
        modal_body: $('#listing-brand-modal').find('.brand-detail-body'),
        brand_detail_stores: $('#listing-brand-modal').find('.brand-detail-stores'),
        brand_detail_stores_list: $('#listing-brand-modal').find('.brand-detail-stores-list'),
        store_detail: $('#listing-brand-modal').find('.brand-store-detail'),
        store_detail_container: $('.store-detail-container'),
    }
}

var href = ''

const BrandModal = {
    modal_id: 'listing-brand-modal',

    getElements: () => getElements(),

    closeModal: () => {
        $(document).on('click', '#listing-brand-modal .modal-close', function(e) {
            MicroModal.default.close(BrandModal.modal_id)
        })

        $(window).click(function(e) {
            if ($(e.target).hasClass('modal-overlay')) {
                MicroModal.default.close(BrandModal.modal_id)
            }
        })
    },

    goBackDetailBrand: function () {
        $(document).on('click', '#back-on-store-detail', function(e) {
            e.preventDefault();
            BrandModal.getElements().brand_detail_stores.removeClass('d-none');
            if(BrandModal.getElements().brand_detail_stores_list.length) {
                BrandModal.getElements().brand_detail_stores_list.removeClass('d-none');
            }
            BrandModal.getElements().store_detail_container.removeClass('show');
           
        })
    },
    stopHref: function () {
        $('.listing-brand-button .brand-detail-a').on( "click", function(e) {
            href = $(e.target).closest('.listing-brand-button .brand-detail-a').attr('href');
            $(e.target).closest('.listing-brand-button .brand-detail-a').attr('href', 'javascript:void(0)');
        })
    },
    getDetails: function() {
        $(document).on('click', '.listing-brand-button .brand-detail-a', function(e) {
            e.stopPropagation();
            e.preventDefault();

            var tile = $(e.target).closest('.listing-brand-button')
            var brandId = tile.data("brandid");
            var url = tile.attr("data-href");

            MicroModal.default.show(BrandModal.modal_id);
            BrandModal.getElements().modal_container.empty();
            BrandModal.getElements().modal_container.spinner().start();
            
            $.ajax({
                url: url,
                type: 'get',
                data: brandId,
                contentType: "application/json; charset=utf-8",
                success: function (response) {
                    BrandModal.getElements().modal_container.spinner().stop();
                    BrandModal.getElements().modal_container.append(response);
                    $(document).find('.listing-brand-button .brand-detail-a').attr('href', href);
                },
                error: function (error) {
                    $(document).find('.listing-brand-button .brand-detail-a').attr('href', href);
                    var t = error
                    console.log('failed')
                }
            })
        })
    },

    getStoreDetails: function() {
        $(document).on('click', '.show-store-detail', function(e) {
            var storeId = $(this).data("storeid").toString();
            var url = $(this).attr("data-href");

            e.preventDefault();

            BrandModal.getElements().brand_detail_stores.addClass('d-none');
            if(BrandModal.getElements().brand_detail_stores_list.length) {
                BrandModal.getElements().brand_detail_stores_list.addClass('d-none');
            }
            BrandModal.getElements().store_detail.remove();
            BrandModal.getElements().modal_container.spinner().start();
            
            $.ajax({
                url: url,
                type: 'get',
                data: storeId,
                contentType: "application/json; charset=utf-8",
                success: function (response) {
                    BrandModal.getElements().modal_container.spinner().stop();
                    BrandModal.getElements().store_detail_container.append(response);
                    BrandModal.getElements().store_detail_container.addClass('show');
                },
                error: function () {
                    console.log('failed')
                }
            })
        })
    }
}
module.exports = BrandModal;